// Service centralisant les appels backend de la fenetre de gestion / envoi des FSE
// (Lot.vue). Porte des fenetres desktop SignFSE.cs / GestionFSE.cs.
// Toutes les actions passent par ici ; Lot.vue n'appelle plus RequestManager en direct.
// Contrat documente dans docs/plans/2026-06-30-gestion-envoi-fse-design.md.
import config from "../config.js";
import RequestManager from "./request.js";

export default class GestionFSE {

    // --- Alimentation grille + praticiens -------------------------------------

    // Liste FSE formatee (avec Code = SDES_CODE pour la selection) selon les filtres.
    static chargerFSE(options) {
        const url = `${config.urlBackEnd}FSE/MajGet2`;
        return RequestManager.post(url, options);
    }

    // Praticiens du filtre : [{ Idps, Nom, Prenom, NoIdFac }].
    static chargerPraticiens() {
        const url = `${config.urlBackEnd}FSE/getPrat`;
        return RequestManager.get(url);
    }

    // --- Selection automatique ------------------------------------------------

    // Codes FSE eligibles a la transmission (signees, non transmises, valides).
    static selectionAuto(options) {
        const url = `${config.urlBackEnd}FSE/selectionAuto`;
        return RequestManager.post(url, options);
    }

    // --- Actions coeur --------------------------------------------------------

    // Signature FSE : NE passe PAS par l'ASP. La signature FSV se fait cote MAUI/Kapelse
    // (la carte CPS est sur le lecteur MAUI). On envoie l'action au pont WebView, comme LireCartePS.
    // Contrat MAUI (handler "SignerFSE", SylyMaui/Platforms/Windows/frmMain.cs) :
    //   parameters[0] = code PIN porteur, parameters[1] = tableau des n° FSE a signer.
    // Fire-and-forget : MAUI signe en asynchrone puis met a jour la base ; la grille se rafraichit au poll.
    static signerFSEViaMaui(codes, pin) {
        RequestManager.EnvoyerMessageWebView({ action: "SignerFSE", parameters: [pin, codes] });
    }

    // Supprime / annule / restaure une FSE : le backend detecte l'etat (comme bDelete du desktop)
    // et appelle la bonne fonction lib. -> { success, annulee, traitementManuel, message }
    static supprimer(code) {
        const url = `${config.urlBackEnd}FSE/supprimerFSE`;
        return RequestManager.post(url, { code });
    }

    // Prepare l'envoi des FSE selectionnees (EnvoyerFseSelection). codePin saisi cote front.
    // -> { success, message }
    static preparerEnvoi(codes, codePin) {
        const url = `${config.urlBackEnd}FSE/preparerEnvoi`;
        return RequestManager.post(url, { codes, codePin });
    }

    // Prepare puis transmet les FSE selectionnees. -> { success, message }
    static transmettre(codes) {
        const url = `${config.urlBackEnd}FSE/transmettre`;
        return RequestManager.post(url, { codes });
    }

    // --- ARL + impressions ----------------------------------------------------

    // Contenu texte de l'ARL d'une FSE. -> { contenu }
    static visualiserARL(code) {
        const url = `${config.urlBackEnd}FSE/visualiserARL?code=${encodeURIComponent(code)}`;
        return RequestManager.get(url);
    }

    // Detail complet d'une facture (texte deja formate, via Strfse.VisualiserActes). -> { contenu }
    static detailsFacture(code) {
        const url = `${config.urlBackEnd}FSE/detailsFacture?code=${encodeURIComponent(code)}`;
        return RequestManager.get(url);
    }

    // Impression de l'ARL (cote serveur). -> { success }
    static imprimerARL(code) {
        const url = `${config.urlBackEnd}FSE/imprimerARL?code=${encodeURIComponent(code)}`;
        return RequestManager.get(url);
    }

    // Impression d'une FSE (cote serveur). -> { success }
    static imprimerFSE(code) {
        const url = `${config.urlBackEnd}FSE/imprimerFSE?code=${encodeURIComponent(code)}`;
        return RequestManager.get(url);
    }

    // Bordereau d'accompagnement IRIS (mise en page reglementaire, cote serveur).
    static bordereauIris(codes) {
        const url = `${config.urlBackEnd}FSE/bordereauIris`;
        return RequestManager.post(url, { codes });
    }

    // --- Exports --------------------------------------------------------------

    // Export CSV des FSE selectionnees : le backend renvoie { csv } ; on telecharge le fichier.
    static async exportCSV(codes) {
        const url = `${config.urlBackEnd}FSE/exportCSV`;
        const r = await RequestManager.post(url, { codes });
        if (r && typeof r.Csv === "string") {
            this.telechargerTexte(r.Csv, "export.csv");
        }
        return r;
    }

    // Export CSV pour reclamation (meme principe).
    static async exportCSVReclamation(codes) {
        const url = `${config.urlBackEnd}FSE/exportCSVReclamation`;
        const r = await RequestManager.post(url, { codes });
        if (r && typeof r.Csv === "string") {
            this.telechargerTexte(r.Csv, "export_reclamation.csv");
        }
        return r;
    }

    // Declenche le telechargement navigateur d'un contenu texte (CSV iso-8859-1 comme le desktop).
    static telechargerTexte(contenu, nomFichier) {
        const blob = new Blob([contenu], { type: "text/csv;charset=iso-8859-1" });
        const lien = document.createElement("a");
        lien.href = URL.createObjectURL(blob);
        lien.download = nomFichier;
        document.body.appendChild(lien);
        lien.click();
        document.body.removeChild(lien);
        URL.revokeObjectURL(lien.href);
    }

    // Export vers Ag2035. -> { success, message }
    static exportAG2035(codes) {
        const url = `${config.urlBackEnd}FSE/exportAG2035`;
        return RequestManager.post(url, { codes });
    }

}
